import React from 'react';
import classNames from 'classnames';

type Props = { label: string; onClick: () => void; isCurrent?: boolean };

const ProjectsTab = (props: Props) => {
  const { label, onClick, isCurrent } = props;

  return (
    <button
      key={label}
      onClick={onClick}
      className={classNames(
        'p-2 font-medium capitalize border-b border-solid transition-all hover:text-black',
        isCurrent
          ? 'text-black border-black'
          : 'text-black/[0.5] border-transparent',
      )}
    >
      {label}
    </button>
  );
};

export default ProjectsTab;
